// @ts-nocheck
/* eslint-disable */
export const flagIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.90667 3.66683L8.17333 5.00016H11.6667V9.00016H9.42667L9.16 7.66683H4.33333V3.66683H7.90667ZM9 2.3335H3V13.6668H4.33333V9.00016H8.06667L8.33333 10.3335H13V3.66683H9.26667L9 2.3335Z" fill="currentColor"/></svg>`,
    name: 'flag' as const
};